import React from 'react';

import type { ReactNode } from 'react';
import Loader from './loader';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode
  loading?: boolean;
  defaultStyle?: boolean;
};

export function Button({
  children,
  className = '',
  type = 'button',
  loading,
  defaultStyle = true,
  ...props
}: ButtonProps) {

  const isLoading = loading === true;
  const isDisabled = props.disabled || isLoading;

  return (
    <button
      type={type}
      className= {`${defaultStyle ? 'btn btn-primary' : "" } ${className}`}
      disabled={isDisabled}
      {...props}
    >
      {isLoading && <Loader />  }
      {children}
    </button>
  );
}
